import React from 'react';

const Bell = (props) => {
    //svg from figma not working with diff color
    // return(
    //     <svg
    //         xmlns="http://www.w3.org/2000/svg"
    //         width="16" height="20"
    //         viewBox="0 0 16 20"
    //         fill="none"
    //         {...props}
    //     >
    //         <path d="M14 13.75V8.75C14 5.68 12.37 3.11 9.5 2.43V1.75C9.5 0.92 8.83 0.25 8 0.25C7.17 0.25 6.5 0.92 6.5 1.75V2.43C3.64 3.11 2 5.67 2 8.75V13.75L0 15.75V16.75H16V15.75L14 13.75ZM8 19.75C9.1 19.75 10 18.85 10 17.75H6C6 18.85 6.9 19.75 8 19.75ZM4 14.75H12V8.75C12 6.27 10.49 4.25 8 4.25C5.51 4.25 4 6.27 4 8.75V14.75Z" fill="#68858D"/>
    //     </svg>
    // )


    //using google icon instead
    return(
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 -960 960 960"
            width="24px" fill="#68858D"
            {...props}
        >
            <path d="M192-216v-72h48v-240q0-87 53.5-153T432-763v-53q0-20 14-34t34-14q20 0 34 14t14 34v53q85 16 138.5 82T720-528v240h48v72H192Zm288-276Zm-.21 396Q450-96 429-117.15T408-168h144q0 30-21.21 51t-51 21ZM312-288h336v-240q0-70-49-119t-119-49q-70 0-119 49t-49 119v240Z"/></svg>

    )
}

export default Bell;